import { useEffect, useRef } from 'react';

import { useLocation } from '@xing-com/crate-core-router';

export const useQueryParamsListener = (
  callback: (params: URLSearchParams) => void
): void => {
  const location = useLocation();
  const callbackRef = useRef(callback);

  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    callbackRef.current(searchParams);
  }, [location.search]);
};
